import module from 'empresa/module.js'
import moment from 'moment'

export const schema = {
  fecha: 'date',
  fecha_operacion: 'date',
}

export class EmpresaReportePldService {
  constructor ($http) {
    this.$http = $http
  }

  get (empresaId, fecha, {fechaOperacion, formato = 'xml'}) {
    return this.$http.get('/api/empresa/reporte/pld', {
        params: {
          empresa_id: empresaId,
          fecha: moment(fecha).format('YYYY-MM-DD'),
          fecha_operacion: moment(fechaOperacion || fecha).format('YYYY-MM-DD'),
          formato: formato.toLowerCase(),
        },
        schema,
        download: true,
      },
    )
  }
}

module.service('EmpresaReportePld', EmpresaReportePldService)



// WEBPACK FOOTER //
// ./src/empresa/services/Empresa/Reporte/Pld.js